import { actionTypes } from './action';

export const arenaDialogState={open:false};

export const arenaDialogReducer = (state = arenaDialogState, action) => {
    switch (action.type) {
        case actionTypes.OPEN_ARENA_DIALOG:
            return action.payload;
        case actionTypes.CLOSE_ARENA_DIALOG:
            return arenaDialogState;
        default:
            return state;
    }
};
